import React from "react";
import { Route } from "react-router-dom";
import AssignLeads from "../../AdminDashboard/EFiling/AssignLeads/AssignLeads";
import All from "../../AdminDashboard/EFiling/All/All";
import Messages from "../../AdminDashboard/EFiling/Messages/Messages";
import NewFile from "../../AdminDashboard/EFiling/NewFile/NewFile";
import DocsPending from "../../AdminDashboard/EFiling/DocsPending/DocsPending";
import CallBack from "../../AdminDashboard/EFiling/CallBack/CallBack";
import CallIndia from "../../AdminDashboard/EFiling/CallIndia/CallIndia";
import Extension from "../../AdminDashboard/EFiling/Extension/Extension";
import Amendment from "../../AdminDashboard/EFiling/Amendment/Amendment";
import Notice from "../../AdminDashboard/EFiling/Notice/Notice";
import NoticeResolved from "../../AdminDashboard/EFiling/NoticeResolved/NoticeResolved";
import ITINAdmin from "../../AdminDashboard/EFiling/ITIN/ITIN";
import EFiling from "../../AdminDashboard/EFiling/EFiling";
import EFilingPending from "../../AdminDashboard/EFiling/EfilingPending/EFilingPending";
import EFilingCompleted from "../../AdminDashboard/EFiling/EFilingCompleted/EFilingCompleted";
import NRPending from "../../AdminDashboard/EFiling/NRPending/NRPending";
import NRFilingPending from "../../AdminDashboard/EFiling/NRFilingPending/NRFilingPending";
import NRFilingCompleted from "../../AdminDashboard/EFiling/NRFilingCompleted/NRFilingCompleted";
import ITINFilingPending from "../../AdminDashboard/EFiling/ITINFilingPending/ITINFilingPending";
import CertificationPending from "../../AdminDashboard/EFiling/CertificationPending/CertificationPending";
import StateFilingPending from "../../AdminDashboard/EFiling/StateFilingPending/StateFilingPending";
import ITINReceived from "../../AdminDashboard/EFiling/ITINReceived/ITINReceived";
import ITINFileCompleted from "../../AdminDashboard/EFiling/ITINFileCompleted/ITINFileCompleted";
import FBAR from "../../AdminDashboard/EFiling/FBAR/FBAR";
const EFilingRoutes = () => {
  return (
    <Route path="e-filing" element={<EFiling />}>
      <Route path="assign-leads" element={<AssignLeads />} />
      <Route path="all" element={<All />} />
      <Route path="messages" element={<Messages />} />
      <Route path="new-file" element={<NewFile />} />
      <Route path="docs-pending" element={<DocsPending />} />
      <Route path="call-back" element={<CallBack />} />
      <Route path="call-india" element={<CallIndia />} />
      <Route path="e-filing-pending" element={<EFilingPending />} />
      <Route path="e-filing-completed" element={<EFilingCompleted />} />
      <Route path="nr-pending" element={<NRPending />} />
      <Route path="nr-filing-pending" element={<NRFilingPending />} />
      <Route path="nr-filing-completed" element={<NRFilingCompleted />} />
      <Route path="itin-filing-pending" element={<ITINFilingPending />} />
      <Route path="certification-pending" element={<CertificationPending />} />
      <Route path="state-filing-pending" element={<StateFilingPending />} />
      <Route path="itin-received" element={<ITINReceived />} />
      <Route path="itin-file-completed" element={<ITINFileCompleted />} />
      <Route path="extension" element={<Extension />} />
      <Route path="amendment" element={<Amendment />} />
      <Route path="fbar" element={<FBAR />} />
      <Route path="notice" element={<Notice />} />
      <Route path="notice-resolved" element={<NoticeResolved />} />
      <Route path="itin" element={<ITINAdmin />} />
    </Route>
  );
};

export default EFilingRoutes;
